import { IconFlask } from "@tabler/icons-react";
import { listActiveMocks, hasAnyMock } from "@/lib/mock-flags";

export function MockBanner() {
  if (!hasAnyMock()) return null;
  const mocks = listActiveMocks();

  return (
    <div className="flex items-center gap-2 border-b border-warning/20 bg-warning-soft px-4 py-1.5 text-[11.5px] font-medium text-warning-ink">
      <IconFlask size={14} className="shrink-0" />
      <span className="truncate">
        Modo mock ativo em: <strong>{mocks.join(", ")}</strong>. Dados são fictícios.
      </span>
    </div>
  );
}
